/**
 * Makes a callback ref that publishes the element's height as a CSS custom
 * property on <html> while it's mounted, so other fixed or sticky elements
 * can offset themselves with `var(<name>, 0px)`. Create it once at module
 * level so the ref keeps a stable identity. Relies on React 19 ref cleanup.
 */
export function heightVarRef(name: `--${string}`) {
  return (node: HTMLElement | null) => {
    if (!node) return
    const root = document.documentElement
    const update = () => root.style.setProperty(name, `${node.offsetHeight}px`)
    update()
    const observer = new ResizeObserver(update)
    observer.observe(node)
    return () => {
      observer.disconnect()
      root.style.removeProperty(name)
    }
  }
}

/**
 * Ref for a screen's sticky bottom action bar (Add to cart, Checkout).
 * Publishes the bar's height as `--toast-clearance` so engineer toasts sit
 * above it instead of covering the button (DEV-51010 AC16).
 */
export const toastClearanceRef = heightVarRef('--toast-clearance')
